import React, { useEffect, useState } from "react";
import { termsAndConditionsApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./termsAndConditions.scss";

const defaultData = {
  _id: null, Title: "Terms & Conditions", Content: "",
};

const TermsAndConditions = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(termsAndConditionsApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const fetchedData = Array.isArray(result.data) ? result.data[0] : result.data;
        if (fetchedData) {
          setFormData(fetchedData);
        }
      }
    } catch (error) {
      console.error("Error fetching Terms & Conditions data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${termsAndConditionsApi}/${formData._id}` : termsAndConditionsApi;
      const response = await apiClient(url, {
        method,
        body: JSON.stringify(formData),
      });

      console.log(`[Frontend] Terms And Conditions Response Status: ${response.status} ${response.statusText}`);
      const result = await response.json();
      console.log('[Frontend] Terms And Conditions Response Body:', result);

      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
      } else {
        console.error('[Frontend] Terms And Conditions save failed:', response.status);
      }
    } catch (error) {
      console.error("Error saving Terms And Conditions data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terms-page">
      <div className="terms-page__header">
        <div><h1>Terms & Conditions</h1><p>Update and manage the terms and conditions policy for the institution.</p></div>
        <button className="save-btn" type="submit" form="termsForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save Policies"}</button>
      </div>

      <form id="termsForm" className="terms-form" onSubmit={handleSubmit}>
        <div className="terms-card">
          <div className="form-section-label">General Configuration</div>
          <div className="form-group"><label>Display Title</label><input type="text" name="Title" value={formData.Title} onChange={handleChange} placeholder="e.g. Terms & Conditions" required /></div>
          
          <div className="form-section-label">Detailed Content</div>
          <div className="form-group"><label>Policy Content</label><textarea name="Content" rows="18" value={formData.Content} onChange={handleChange} placeholder="Describe the terms and conditions..." required /></div>
        </div>
      </form>
    </div>
  );
};

export default TermsAndConditions;
